import { useContext } from 'react';
import {AuthStore} from './context';

export function useAuthStore() {
  return useContext(AuthStore);
}
